import { Component, OnInit, Input, Output, EventEmitter , ElementRef, HostListener, ViewChild } from '@angular/core';
import { Product } from '../../../../shared/classes/product';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent implements OnInit {
  @ViewChild('dropdown', { static: false }) dropdownRef!: ElementRef;

  @Input() products: Product[] = [];
  @Input() paginate: any = {};
  @Input() layoutView: string = 'grid-view';
  @Input() sortBy: string;

  @Output() setGrid: EventEmitter<any> = new EventEmitter<any>();
  @Output() setLayout: EventEmitter<any> = new EventEmitter<any>();
  @Output() sortedBy: EventEmitter<any> = new EventEmitter<any>();
  @Output() mobileSidebarChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public commonService: CommonService
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    console.log(this.sortBy);
    this.sortingBy= this.sortBy;
    this.getSelectedLabel();
  }

  setGridLayout(value: string) {
    this.setGrid.emit(value);  
  }

  setLayoutView(value: string) {
    this.layoutView = value
    this.setLayout.emit(value); 
  }

  toggleMobileSidebar() {
    this.mobileSidebarChange.emit()
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.dropdownRef?.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.openDropdown = false;
    }
  }

  sorting(value: any) {
    console.log(value);
    this.sortedBy.emit(value);
  }

  sortingBy = '';
  openDropdown = false;
  
  toggleDropdown() {
    this.openDropdown = !this.openDropdown;
  }
  
  selectSort(value: string) {
    this.sortingBy = value;
    this.sorting(value);
    this.openDropdown = false;
  }
  
  getSelectedLabel() {
    switch (this.sortingBy) {
      case '': return 'recomended';
      case 'new': return 'newProduct';
      case 'discount': return 'highDiscount';
      case 'a-z': return 'AlphabeticallyA-Z';
      case 'z-a': return 'AlphabeticallyZ-A';
      case 'low': return 'PriceLowtoHigh';
      case 'high': return 'PriceHightoLow';
      default: return 'newProduct';
    }
  }
}
